const InspectorPersonMenu = (props: any) => (
    <svg
        width={24}
        height={25}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8 7.32324C8 8.38411 8.42143 9.40152 9.17157 10.1517C9.92172 10.9018 10.9391 11.3232 12 11.3232C13.0609 11.3232 14.0783 10.9018 14.8284 10.1517C15.5786 9.40152 16 8.38411 16 7.32324C16 6.26238 15.5786 5.24496 14.8284 4.49481C14.0783 3.74467 13.0609 3.32324 12 3.32324C10.9391 3.32324 9.92172 3.74467 9.17157 4.49481C8.42143 5.24496 8 6.26238 8 7.32324Z"
            stroke="#98A2B3"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6 21.3232V19.3232C6 18.2624 6.42143 17.245 7.17157 16.4948C7.92172 15.7447 8.93913 15.3232 10 15.3232H14C15.0609 15.3232 16.0783 15.7447 16.8284 16.4948C17.5786 17.245 18 18.2624 18 19.3232V21.3232"
            stroke="#98A2B3"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default InspectorPersonMenu;
